export const FiltersModel = Backbone.Model.extend({
  defaults: {
    ACTIVITIES: [],
    PRICE: '',
    CLASSIFICATIONCOMFORT: [],
    HOUSINGCATEGORY: [],
    HOUSINGSPEC: [],
    NUMBEROFBEDROOMS: [],
    EQUIPMENT: [],
    filterHebergementsType: typeof filterHebergementsType !== 'undefined' ? filterHebergementsType : null,
    PROMOCODE: '',
    resume: {},
    lastModifiedFilter: '',
    selectionOrder: SEARCH_SCRIPTS.DEFAULT_FILTERS_CHECKED_ORDER.reverse(), // récupération des order de selection par défauts et en le reverse (last => displayed first)
    isResetAllFilters: false // marqueur permettant d'indiquer si des rendus de filtres doivent être lancés
  },

  initialize() {
    this.defaultValues = SEARCH_SCRIPTS.DEFAULT_FILTERS_CHECKED_VALUES;

    //récupération des valeurs par défauts
    //on ne les déclare pas directement dans l'objet defaults de manière à pouvoir réaliser un reset des filtres
    this.set(this.defaultValues, {silent: true});

    //gestion des model watch
    this.stopListening(this, 'change');
    this.listenTo(this, 'change', this.modelWatch, true);

    this.stopListening(dispatcher, 'filterModel:reset');
    this.listenTo(dispatcher, 'filterModel:reset', this.resetModel);

    this.stopListening(dispatcher, 'filterModel:resetLastFilter');
    this.listenTo(dispatcher, 'filterModel:resetLastFilter', this.resetLastFilter);
  },

  /**
   * Get resume of this model
   * @return {Object}
   */
  getResume: function () {
    const resume = {
      ACTIVITIES: this.get('ACTIVITIES'),
      PRICE: this.get('PRICE'),
      CLASSIFICATIONCOMFORT: this.get('CLASSIFICATIONCOMFORT'),
      HOUSINGCATEGORY: this.get('HOUSINGCATEGORY'),
      HOUSINGSPEC: this.get('HOUSINGSPEC'),
      NUMBEROFBEDROOMS: this.get('NUMBEROFBEDROOMS'),
      EQUIPMENT: this.get('EQUIPMENT'),
      PROMOCODE: this.get('PROMOCODE'),
      filterHebergementsType: this.get('filterHebergementsType')
    };

    this.set('resume', resume, {'silent': true});
    return resume;
  },

  /**
   * Récupération des filtres sous une valeur exploitable pour l'elasticSearch
   * @return {Object}
   */
  getFiltersValues: function () {
    const filters = {
        ACTIVITIES: this.get('ACTIVITIES'),
        PRICE: this.get('PRICE'),
        CLASSIFICATIONCOMFORT: this.get('CLASSIFICATIONCOMFORT'),
        HOUSINGCATEGORY: this.get('HOUSINGCATEGORY'),
        HOUSINGSPEC: this.get('HOUSINGSPEC'),
        NUMBEROFBEDROOMS: this.get('NUMBEROFBEDROOMS'),
        EQUIPMENT: this.get('EQUIPMENT'),
        PROMOCODE: this.get('PROMOCODE')
      },
      filtersValues = {};
    if (!$.isEmptyObject(filters)) {
      $.each(filters, (facetteName, value) => {
        if (facetteName === 'PRICE' && value.length) {
          if (SEARCH_SCRIPTS.IS_FACETTE_BUDGET_SELECTED) {
            const arrBudget = value.split('_');
            filtersValues[`facet[${facetteName}][min]`] = arrBudget[0];
            filtersValues[`facet[${facetteName}][max]`] = arrBudget[1];
          }
        } else if (facetteName === 'PROMOCODE' && value !== '' && value !== null) {
          // if faut convertir la chaine, qui peut contenir plusieurs promocodes séparés par une virgule, en tableau
          // la valeur doit être convertie en string, parce qu'elle est parfois sous la forme d'un entier (quand il n'y a qu'un code)
          filtersValues['facet[PROMOCODE][]'] = value.toString().split(',');
        } else {
          // on n'envoie pas les facettes vides
          if (filters[facetteName] !== null && filters[facetteName].length) {
            filtersValues['facet[' + facetteName + '][]'] = value;
          }
        }
      });
    }

    return filtersValues;
  },

  modelWatch: function () {
    const arrKeys = Object.keys(this.changedAttributes());
    const arrKeysToWatch = [
      'ACTIVITIES',
      'PRICE',
      'CLASSIFICATIONCOMFORT',
      'HOUSINGCATEGORY',
      'HOUSINGSPEC',
      'NUMBEROFBEDROOMS',
      'EQUIPMENT',
      'PROMOCODE'
    ];

    if (_.intersection(arrKeys, arrKeysToWatch).length) {
      // Affichage du loader pour le filtre actif s'il est concerné par une correlation interne
      if (['ACTIVITIES', 'HOUSINGCATEGORY', 'HOUSINGSPEC', 'NUMBEROFBEDROOMS', 'EQUIPMENT'].some(item => arrKeys.includes(item))) {
        loader.display('.js-searchFilters-globalContainer');
      }
      dispatcher.trigger('search:displayLoader', 10);

      const updateParams = {
        isTemporaryModel: false,
        arrKeys: arrKeys
      };
      dispatcher.trigger('searchModel:globalSearchUpdate', updateParams);
    }
  },

  resetLastFilter: function () {
    this.set({lastModifiedFilter: null});
  },

  resetModel: function (silentMode = false) {
    this.set(this.defaults, {silent: silentMode});
  }
});
